"use client";

import {
  Drawer,
  DrawerContent,
  DrawerHeader,
  DrawerTitle,
  DrawerTrigger,
  DrawerClose,
  Close,
  Button,
} from "@oreme/ui";
import { SlidersHorizontal } from "lucide-react";
import { useTranslations } from "next-intl";
import React, { type ReactElement } from "react";
import { DevicesSidebar } from "@/components";

function DevicesDrawer(): ReactElement {
  const t = useTranslations("devices.Drawer");
  return (
    <Drawer defaultOpen={false} direction="right">
      <DrawerTrigger>
        <SlidersHorizontal size={20} strokeWidth={1} />
      </DrawerTrigger>
      <DrawerContent
        className="fixed inset-0 left-auto w-96 h-dvh flex flex-col rounded-none p-0 m-0 overflow-y-auto overflow-x-hidden"
        data-vaul-no-drag
      >
        <DrawerHeader className="relative text-left leading-tight">
          <DrawerTitle className="sr-only">{t("title")}</DrawerTitle>
          <DrawerClose className="absolute top-4 right-3">
            <Button variant="ghost" size="icon" asChild>
              <Close title={t("close")} aria-label={t("close")} />
            </Button>
          </DrawerClose>
        </DrawerHeader>
        <div className="flex-1 min-h-0">
          <div className="h-full overflow-y-auto [-webkit-overflow-scrolling:touch]">
            <aside className="flex-1 flex flex-col">
              <DevicesSidebar />
            </aside>
          </div>
        </div>
      </DrawerContent>
    </Drawer>
  );
}

export { DevicesDrawer };
